import HeroSection from './HeroSection';
import StatsSection from './StatsSection';
import AcademicsSection from './AcademicsSection';
import ExperienceSection from './ExperienceSection';
import AchievementsSection from './AchievementsSection';
import PassionsSection from './PassionsSection';
import CTASection from './CTASection';

const Home = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <HeroSection />
      <StatsSection />
      <AcademicsSection />
      <ExperienceSection />
      <AchievementsSection />
      <PassionsSection />
      <CTASection />
    </div>
  );
};

export default Home;
